import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import { HEATMAP_COLORS } from 'constants/maps'

const styles = theme => ({
  root: {
    opacity: 0,
    left: '50%',
    borderRadius: 8,
    position: 'absolute',
    pointerEvents: 'none',
    top: theme.spacing(4),
    padding: theme.spacing(1) + 2,
    transition: 'all .3s ease',
    transform: 'translate(-50%, -10px)',
    backgroundColor: theme.palette.white,
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
    marginTop: theme.spacing(0.5),
  },
  open: {
    opacity: 1,
    transform: 'translateX(-50%)',
    transition: 'all .3s ease .5s',
  },
  barLabels: {
    height: 10,
    display: 'flex',
    transform: 'translateY(-10px)',
    justifyContent: 'space-between',
    color: theme.palette.text.disabled,
  },
  bars: {
    display: 'flex',
  },
  bar: {
    width: 56,
    height: 10,
  },
})

const HeatmapHelper = ({ classes, open }) => (
  <div className={classNames(classes.root, open && classes.open)}>
    <Typography className={classes.title}>Humane kill density</Typography>
    <div className={classes.barLabels}>
      <Typography>0</Typography>
      <Typography>50+</Typography>
    </div>
    <div className={classes.bars}>
      {HEATMAP_COLORS.map(backgroundColor => (
        <div
          key={backgroundColor}
          className={classes.bar}
          style={{ backgroundColor }}
        />
      ))}
    </div>
  </div>
)

HeatmapHelper.propTypes = {
  open: PropTypes.bool,
  classes: PropTypes.object,
}

export default withStyles(styles)(HeatmapHelper)



// WEBPACK FOOTER //
// ./src/components/atoms/HeatmapHelper.js